export enum Applications {
  OFFICE = 'office',
  TECHNICIAN = 'technician',
  ACCOUNT = 'account',
}
